__turbopack_context__.v({
  "border": "SubHeaderTitle-module-scss-module__NzZgha__border",
  "count": "SubHeaderTitle-module-scss-module__NzZgha__count",
  "inner_wrap": "SubHeaderTitle-module-scss-module__NzZgha__inner_wrap",
  "title": "SubHeaderTitle-module-scss-module__NzZgha__title",
  "wrap": "SubHeaderTitle-module-scss-module__NzZgha__wrap",
});
